export default function initPrefetchLinks(){
    const anchors = document.querySelectorAll("a");
    anchors.forEach(anchor => {
        anchor.addEventListener("mouseenter", function (){
            prefetchLink(anchor);
        }, { once: true });
    });
}

function prefetchLink(anchor){
    const href = anchor.getAttribute("href");

    if(href){
        const linkUrl = new URL(href, window.location.href);
        const existingLink = document.querySelector(`link[rel=prefetch][href="${linkUrl.href}"]`);

        if(!existingLink && window.location.host === linkUrl.host){
            const link = document.createElement("link");
            link.setAttribute("rel", "prefetch");
            link.setAttribute("href", linkUrl.href);
            document.head.appendChild(link);
        }
    }
}